export default __webpack_public_path__ + "static/media/leaf1.c9777c99.svg";